(function ($) {
  const blogBody = $('.blogBody');
  const blogIntro = blogBody.find('p:eq(0)');
  const blogReadMinutes = parseInt($('.blogReadMinutes').html());
  const backToTop = $('.backToTop');

  buildOverview();

  function buildOverview() {
    if (blogReadMinutes > 4) {
      blogIntro.after(
        "<div class='blogContentOverview'><span class='blogContentOverview__title'>Snel naar inhoud gaan</span><ul class='blogContentTable'></ul></div>",
      );
    }
  }

  const blogBodyTitle = $('.blogBody > h2');
  const blogContentTable = $('.blogContentTable');

  if (blogReadMinutes > 4) {
    blogBodyTitle.each(function (n) {
      const blogBodyTitleID = `h2_${n}`;
      $(this).attr('id', blogBodyTitleID);

      const blogContentTableRow = $('<li>').addClass('blogContentTableRow');
      const blogContentTableRowLink = $('<a>', {
        text: $(this).text(),
        href: `#${blogBodyTitleID}`,
        title: $(this).text(),
      });

      blogContentTableRowLink.appendTo(blogContentTableRow);
      blogContentTable.append(blogContentTableRow);

      blogContentTableRowLink.click(function (e) {
        e.preventDefault();
        const aid = $(this).attr('href');
        $('html,body').animate(
          { scrollTop: $(aid).offset().top - 140 },
          'slow',
        );
      });
    });

    backToTop.click((e) => {
      e.preventDefault();
      $('html,body').animate({ scrollTop: 0 }, 'slow');
    });
  }

  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      backToTop.addClass('visible');
    } else {
      backToTop.removeClass('visible');
    }
  });
}(jQuery));
